import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef
} from '@angular/material/dialog';
import {
    IconTheme,
    TapestryButtonModule,
    TapestryIconButtonModule,
    TapestryNotificationService
} from '@predictiveindex/tapestry';
import { catchError, of } from 'rxjs';
import { CompanyClassificationType } from '../../../../../constants-types';
import {
    ClassificationType,
    SellerToolsAccountTableData
} from '../../../../../core-data-model';
import {
    CompaniesDataService,
    DemoAccountsRepositoryService
} from '../../../../../core-services';
import {
    TranslationService,
    TranslationsModule
} from '../../../../../translations';

@Component({
    selector: 'delete-account-modal',
    imports: [
        TapestryIconButtonModule,
        MatDialogModule,
        TranslationsModule,
        TapestryButtonModule
    ],
    templateUrl: './delete-account-modal.component.html',
    styleUrls: ['./delete-account-modal.component.less']
})
export class DeleteAccountModalComponent {
    dialogData: SellerToolsAccountTableData = inject(MAT_DIALOG_DATA);
    saving: boolean;

    protected readonly IconTheme = IconTheme;

    private dialogRef = inject(MatDialogRef<DeleteAccountModalComponent>);
    private demoAccountsRepository = inject(DemoAccountsRepositoryService);
    private tapestryNotification = inject(TapestryNotificationService);
    private companiesData = inject(CompaniesDataService);
    private TR = inject(TranslationService);
    private destroyRef = inject(DestroyRef);

    cancel(event: MouseEvent) {
        event.preventDefault();
        this.dialogRef.close();
    }

    save(event: MouseEvent) {
        event.preventDefault();
        this.saving = true;
        this.demoAccountsRepository
            .deleteDemoAccount(this.dialogData.companyGuid)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                catchError((err) => of(err))
            )
            .subscribe(async (err) => {
                if (!err) {
                    this.saving = false;
                    await this.companiesData.deleteCompany(
                        this.dialogData.companyGuid,
                        this.dialogData.accountName,
                        this.toCompanyClassificationType(
                            this.dialogData.demoDataClassificationType
                        )
                    );
                    this.tapestryNotification.create({
                        message: this.TR.keyFormatter(
                            'platform.seller-tools-peek.accounts.delete-modal.notification-success',
                            this.dialogData.accountName
                        ),
                        type: 'success',
                        duration: 3000
                    });
                } else {
                    this.tapestryNotification.create({
                        message: this.TR.keyFormatter(
                            'platform.seller-tools-peek.accounts.delete-modal.notification-failure',
                            this.dialogData.accountName
                        ),
                        type: 'error'
                    });
                }

                this.saving = false;
                this.dialogRef.close();
            });
    }

    private toCompanyClassificationType(
        value: ClassificationType
    ): CompanyClassificationType {
        switch (value) {
            case ClassificationType.DynamicDemo:
                return CompanyClassificationType.DynamicDemo;
            case ClassificationType.Workshop:
                return CompanyClassificationType.Workshop;
        }
    }
}
